/**
 * FRHeal — точечное удаление: прыщ, родинка, соринка, блик от вспышки.
 *
 * ПОЧЕМУ ЭТО СДЕЛАНО РУКАМИ, А НЕ АВТОМАТОМ. Автоматический поиск дефектов
 * рукописными локальными признаками на этом же корпусе провалился: замеренная
 * разделимость «прыщ / чистая кожа» — 0.06…0.30 при пороге, где решение имеет
 * смысл, потому что на масштабе прыща сама кожа откликается сильнее прыща
 * (память reference_spot_removal_needs_a_model_not_a_local_feature). Вывод из
 * того замера был не «нельзя», а «нельзя УГАДЫВАТЬ». Указание места человеком
 * снимает ровно ту часть задачи, которая не решается: ГДЕ. Остаётся ЧЕМ
 * закрыть — а это не распознавание, а перенос куска кожи, и он решается точно.
 *
 * Метод — «лечащая кисть», а не «штамп», и разница между ними здесь главная:
 *
 *   штамп     — копирует донорский кусок как есть; на щеке со светотенью
 *               остаётся видимая заплатка другой яркости;
 *   лечащая   — копирует ТЕКСТУРУ донора, но подгоняет её освещённость под
 *               место назначения. Мы делаем это плоскостью: по кольцу вокруг
 *               пятна считается разница «здесь минус донор», в неё вписывается
 *               линейная плоскость a + b·x + c·y (по каждому каналу), и она
 *               прибавляется к донору. Плоскость — потому что свет на коже в
 *               пределах 30 пикселей меняется плавно и почти линейно; на
 *               большем куске это перестало бы быть правдой, но большой кусок
 *               и не лечат, а перерисовывают.
 *
 * Донор ищется по КОЛЬЦУ вокруг пятна: кожа рядом — самая похожая кожа,
 * какая вообще есть на снимке. Кандидаты сравниваются по краю (SSD на рамке),
 * а не по середине: середина донора нам как раз и нужна ЧУЖАЯ, а сойтись
 * обязаны края — иначе будет шов.
 *
 * Операции хранятся в ДОЛЯХ кадра и переигрываются на полном размере при
 * сохранении — тот же приём, что у модели блика: разбор на превью, выдача в
 * исходном разрешении.
 *
 * Публичный интерфейс — window.FRHeal:
 *   apply(planes, ops, {mask})  → новые плоскости (исходные не меняются)
 *   applyOne(planes, op, {mask})→ на месте, для предпросмотра одного мазка
 */
(function (root) {
    'use strict';

    /** Копия плоскостей: операции не имеют права портить исходник — из него
     *  собирается результат заново при каждой отмене. */
    function clonePlanes(pl) {
        return {
            w: pl.w, h: pl.h, clip: pl.clip,
            R: Float32Array.from(pl.R), G: Float32Array.from(pl.G), B: Float32Array.from(pl.B),
        };
    }

    /**
     * Лучший донор вокруг пятна — СДВИГ (dx, dy) в пикселях, или null.
     * Кандидаты — кольцо вокруг, шестнадцать направлений на трёх расстояниях:
     * ближе — похожее освещение, дальше — больше шансов уйти от соседнего
     * дефекта (прыщи ходят группами). Сравнение — SSD по КОЛЬЦУ: сходиться
     * должны края, а не середина.
     */
    function findDonor(pl, cx, cy, r, o) {
        o = o || {};
        var w = pl.w, h = pl.h;
        // Рамка сравнения — кольцо толщиной в четверть радиуса снаружи пятна.
        var R2 = r * r, RO = Math.round(r * 1.35), RO2 = RO * RO;
        var best = null, bestErr = Infinity;
        var dists = [2.2, 3.2, 4.6];
        for (var d = 0; d < dists.length; d++) {
            var dist = Math.round(r * dists[d]);
            for (var a = 0; a < 16; a++) {
                var ang = a * Math.PI / 8;
                var dx = Math.round(Math.cos(ang) * dist), dy = Math.round(Math.sin(ang) * dist);
                var sx = cx + dx, sy = cy + dy;
                if (sx - RO < 0 || sy - RO < 0 || sx + RO >= w || sy + RO >= h) continue;
                if (o.mask && o.mask[sy * w + sx] < 0.5) continue;   // донор обязан быть кожей
                var err = 0, cnt = 0;
                for (var yy = -RO; yy <= RO; yy += 2) {
                    for (var xx = -RO; xx <= RO; xx += 2) {
                        var q = xx * xx + yy * yy;
                        if (q < R2 || q > RO2) continue;
                        var ti = (cy + yy) * w + (cx + xx);
                        var si = (sy + yy) * w + (sx + xx);
                        if (ti < 0 || ti >= w * h || si < 0 || si >= w * h) continue;
                        var er = pl.R[ti] - pl.R[si], eg = pl.G[ti] - pl.G[si], eb = pl.B[ti] - pl.B[si];
                        err += er * er + eg * eg + eb * eb; cnt++;
                    }
                }
                if (!cnt) continue;
                err /= cnt;
                if (err < bestErr) { bestErr = err; best = { dx: dx, dy: dy }; }
            }
        }
        return best ? { dx: best.dx, dy: best.dy, err: bestErr } : null;
    }

    /**
     * Перенос с ИЗВЕСТНЫМ донором: подгонка освещённости плоскостью по кольцу
     * и растушёванный перенос. Плоскости меняются НА МЕСТЕ.
     * `o.strict` — донор и цель обязаны целиком лежать в кадре (видео: сдвиг
     * задан заранее и мог уехать к краю области; у фото его отобрал поиск).
     */
    function healAt(pl, cx, cy, r, dx, dy, o) {
        o = o || {};
        var w = pl.w, h = pl.h;
        var R2 = r * r, RO = Math.round(r * 1.35), RO2 = RO * RO;
        if (o.strict) {
            if (cx - RO < 0 || cy - RO < 0 || cx + RO >= w || cy + RO >= h) return false;
            var sx0 = cx + dx, sy0 = cy + dy;
            if (sx0 - RO < 0 || sy0 - RO < 0 || sx0 + RO >= w || sy0 + RO >= h) return false;
        }
        var best = { dx: dx, dy: dy };

        // ── подгонка освещённости: плоскость по разнице на кольце ───────────
        // Наименьшие квадраты для a + b·x + c·y отдельно по каналу. Система
        // 3×3 симметрична, решается в лоб — матрица крошечная, и городить
        // общий решатель ради неё значило бы прятать три формулы за слоем.
        var S = [0, 0, 0, 0, 0, 0];   // n, Σx, Σy, Σx², Σxy, Σy²
        var T = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];   // Σd, Σdx, Σdy по каналам
        for (var yy2 = -RO; yy2 <= RO; yy2++) {
            for (var xx2 = -RO; xx2 <= RO; xx2++) {
                var q2 = xx2 * xx2 + yy2 * yy2;
                if (q2 < R2 || q2 > RO2) continue;
                var ti2 = (cy + yy2) * w + (cx + xx2);
                var si2 = (cy + best.dy + yy2) * w + (cx + best.dx + xx2);
                if (ti2 < 0 || ti2 >= w * h || si2 < 0 || si2 >= w * h) continue;
                S[0]++; S[1] += xx2; S[2] += yy2;
                S[3] += xx2 * xx2; S[4] += xx2 * yy2; S[5] += yy2 * yy2;
                var dR = pl.R[ti2] - pl.R[si2], dG = pl.G[ti2] - pl.G[si2], dB = pl.B[ti2] - pl.B[si2];
                T[0][0] += dR; T[0][1] += dR * xx2; T[0][2] += dR * yy2;
                T[1][0] += dG; T[1][1] += dG * xx2; T[1][2] += dG * yy2;
                T[2][0] += dB; T[2][1] += dB * xx2; T[2][2] += dB * yy2;
            }
        }
        if (S[0] < 8) return false;
        var plane = [];
        for (var ch = 0; ch < 3; ch++) plane.push(solve3(S, T[ch]));

        // ── перенос ─────────────────────────────────────────────────────────
        // Край мазка растушёван: жёсткая окружность видна на коже как круг,
        // даже когда яркость сошлась идеально.
        var featherFrom = r * 0.62;
        var out = { R: pl.R, G: pl.G, B: pl.B };
        for (var y3 = -r; y3 <= r; y3++) {
            for (var x3 = -r; x3 <= r; x3++) {
                var dd = Math.sqrt(x3 * x3 + y3 * y3);
                if (dd > r) continue;
                var tx = cx + x3, ty = cy + y3;
                if (tx < 0 || ty < 0 || tx >= w || ty >= h) continue;
                var ti3 = ty * w + tx;
                var si3 = (cy + best.dy + y3) * w + (cx + best.dx + x3);
                if (si3 < 0 || si3 >= w * h) continue;
                var al = dd <= featherFrom ? 1 : Math.max(0, 1 - (dd - featherFrom) / Math.max(1e-6, r - featherFrom));
                al = al * al * (3 - 2 * al);   // сглаживание края (smoothstep)
                if (o.mask) al *= Math.min(1, o.mask[ti3] * 1.6);
                if (al <= 0.002) continue;
                var nR = pl.R[si3] + plane[0][0] + plane[0][1] * x3 + plane[0][2] * y3;
                var nG = pl.G[si3] + plane[1][0] + plane[1][1] * x3 + plane[1][2] * y3;
                var nB = pl.B[si3] + plane[2][0] + plane[2][1] * x3 + plane[2][2] * y3;
                out.R[ti3] = clamp01(pl.R[ti3] + (nR - pl.R[ti3]) * al);
                out.G[ti3] = clamp01(pl.G[ti3] + (nG - pl.G[ti3]) * al);
                out.B[ti3] = clamp01(pl.B[ti3] + (nB - pl.B[ti3]) * al);
            }
        }
        return true;
    }

    /**
     * Один мазок (фото): найти донора и перенести.
     *
     * @param {object} pl  плоскости, меняются НА МЕСТЕ
     * @param {object} op  {x,y,r} в долях кадра (r — доля БОЛЬШЕЙ стороны)
     * @param {object} o   {mask} — не выходить за кожу, если маска известна
     * @returns {boolean}  удалось ли (донор не нашёлся → false, кадр не тронут)
     */
    function applyOne(pl, op, o) {
        o = o || {};
        var w = pl.w, h = pl.h;
        var base = Math.max(w, h);
        var cx = Math.round(op.x * w), cy = Math.round(op.y * h);
        var r = Math.max(3, Math.round(op.r * base));
        if (cx < 0 || cy < 0 || cx >= w || cy >= h) return false;
        var best = findDonor(pl, cx, cy, r, o);
        if (!best) return false;
        return healAt(pl, cx, cy, r, best.dx, best.dy, o);
    }

    // ── Видео: пятно, отмеченное на ОДНОМ кадре, — на всём ролике ────────────
    // Пятно запоминается не координатой кадра (лицо движется), а относительно
    // ближайших точек лица MediaPipe: на другом кадре эти точки дают локальную
    // аффинную подгонку (сдвиг, поворот, масштаб, наклон), и по ней переносятся
    // и центр пятна, и ДОНОР. Донор выбран один раз, на отмеченном кадре: если
    // искать его заново на каждом кадре, соседние кадры брали бы кожу с разных
    // мест, и текстура внутри пятна дрожала бы. Свет подгоняется плоскостью на
    // каждом кадре заново — он как раз меняется.
    var SPOT_K = 12;

    /**
     * @param {Array} pts  точки главного лица кадра, {x,y} в долях кадра
     * @param {number} W,H размер кадра в пикселях
     * @param {number} x,y,r  центр и радиус пятна в пикселях этого кадра
     * @param {object} donor  {dx,dy} — сдвиг донора, найденный findDonor
     */
    function makeSpot(pts, W, H, x, y, r, donor) {
        if (!pts || pts.length < SPOT_K || !donor) return null;
        var ds = [];
        for (var i = 0; i < pts.length; i++) {
            var ex = pts[i].x * W - x, ey = pts[i].y * H - y;
            ds.push([ex * ex + ey * ey, i]);
        }
        ds.sort(function (a, b) { return a[0] - b[0]; });
        var idx = [], ref = [];
        for (var k = 0; k < SPOT_K; k++) {
            var j = ds[k][1];
            idx.push(j); ref.push([pts[j].x * W, pts[j].y * H]);
        }
        return { idx: idx, ref: ref, p: [x, y], d: [donor.dx, donor.dy], r: r };
    }

    /**
     * Где пятно на ЭТОМ кадре: {x, y, r, dx, dy} в пикселях, или null, если
     * локальная подгонка вырождена (лицо развернулось, точки перепутались).
     */
    function trackSpot(spot, pts, W, H) {
        if (!spot || !pts) return null;
        var K = spot.idx.length, sx = 0, sy = 0, tx = 0, ty = 0, n = 0;
        var src = [], dst = [];
        for (var k = 0; k < K; k++) {
            var q = pts[spot.idx[k]];
            if (!q) continue;
            src.push(spot.ref[k]); dst.push([q.x * W, q.y * H]);
            sx += spot.ref[k][0]; sy += spot.ref[k][1]; tx += q.x * W; ty += q.y * H; n++;
        }
        if (n < 3) return null;
        sx /= n; sy /= n; tx /= n; ty /= n;
        // A = (Σ d'·s'ᵀ)(Σ s'·s'ᵀ)⁻¹ на центрированных точках.
        var a11 = 0, a12 = 0, a22 = 0, b11 = 0, b12 = 0, b21 = 0, b22 = 0;
        for (var i = 0; i < n; i++) {
            var u = src[i][0] - sx, v = src[i][1] - sy, U = dst[i][0] - tx, V = dst[i][1] - ty;
            a11 += u * u; a12 += u * v; a22 += v * v;
            b11 += U * u; b12 += U * v; b21 += V * u; b22 += V * v;
        }
        var det = a11 * a22 - a12 * a12;
        if (!(Math.abs(det) > 1e-9)) return null;
        var i11 = a22 / det, i12 = -a12 / det, i22 = a11 / det;
        var A00 = b11 * i11 + b12 * i12, A01 = b11 * i12 + b12 * i22;
        var A10 = b21 * i11 + b22 * i12, A11 = b21 * i12 + b22 * i22;
        var dA = A00 * A11 - A01 * A10;
        if (!(dA > 0.15 && dA < 8)) return null;
        var map = function (x, y) {
            var u2 = x - sx, v2 = y - sy;
            return [tx + A00 * u2 + A01 * v2, ty + A10 * u2 + A11 * v2];
        };
        var c = map(spot.p[0], spot.p[1]);
        var dn = map(spot.p[0] + spot.d[0], spot.p[1] + spot.d[1]);
        var r = Math.max(3, Math.round(spot.r * Math.sqrt(dA)));
        var cx = Math.round(c[0]), cy = Math.round(c[1]);
        return { x: cx, y: cy, r: r, dx: Math.round(dn[0]) - cx, dy: Math.round(dn[1]) - cy };
    }

    /** Пятна видео на плоскостях кадра (НА МЕСТЕ). → сколько удалось. */
    function healSpots(pl, spots, pts, W, H) {
        var done = 0;
        for (var i = 0; i < spots.length; i++) {
            var t = trackSpot(spots[i], pts, W, H);
            if (t && healAt(pl, t.x, t.y, t.r, t.dx, t.dy, { strict: true })) done++;
        }
        return done;
    }

    function clamp01(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }

    /**
     * Решение 3×3 для наименьших квадратов плоскости. Матрица собрана из
     * моментов кольца, поэтому она симметрична и почти всегда хорошо
     * обусловлена; вырожденный случай (кольцо схлопнулось в линию) отдаёт
     * ЧИСТЫЙ СДВИГ — то есть штамп со средней поправкой, что заметно хуже
     * плоскости, но всё ещё лучше отказа.
     */
    function solve3(S, t) {
        var m = [
            [S[0], S[1], S[2]],
            [S[1], S[3], S[4]],
            [S[2], S[4], S[5]],
        ];
        var det =
            m[0][0] * (m[1][1] * m[2][2] - m[1][2] * m[2][1]) -
            m[0][1] * (m[1][0] * m[2][2] - m[1][2] * m[2][0]) +
            m[0][2] * (m[1][0] * m[2][1] - m[1][1] * m[2][0]);
        if (!isFinite(det) || Math.abs(det) < 1e-12) return [S[0] ? t[0] / S[0] : 0, 0, 0];
        var inv = function (i, j) {
            var a = (i + 1) % 3, b = (i + 2) % 3, c = (j + 1) % 3, d = (j + 2) % 3;
            return (m[c][a] * m[d][b] - m[c][b] * m[d][a]) / det;
        };
        return [
            inv(0, 0) * t[0] + inv(0, 1) * t[1] + inv(0, 2) * t[2],
            inv(1, 0) * t[0] + inv(1, 1) * t[1] + inv(1, 2) * t[2],
            inv(2, 0) * t[0] + inv(2, 1) * t[1] + inv(2, 2) * t[2],
        ];
    }

    /**
     * Переиграть весь список мазков на копии плоскостей.
     * Именно так работает и предпросмотр (при отмене список короче на один),
     * и сохранение (те же доли кадра, но плоскости полного размера).
     */
    function apply(pl, ops, o) {
        if (!ops || !ops.length) return pl;
        var out = clonePlanes(pl);
        var done = 0;
        for (var i = 0; i < ops.length; i++) {
            if (applyOne(out, ops[i], o)) done++;
        }
        out.healed = done;
        return out;
    }

    root.FRHeal = {
        apply: apply, applyOne: applyOne, clonePlanes: clonePlanes,
        findDonor: findDonor, healAt: healAt, makeSpot: makeSpot, trackSpot: trackSpot, healSpots: healSpots,
    };
})(typeof window !== 'undefined' ? window : globalThis);
